export const biology12 = [
  {
    id: 'bio121',
    image: require('../assets/images/simulation/bio/12/arshola-observation.jpg'),
    name: 'Observe grasshopper/cockroach mouthparts.',
    title: 'Animal Identity - Cockroach',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio122',
    image: require('../assets/images/simulation/bio/12/hyrda-observation.jpg'),
    name: 'Observe permanent slide or model of Hydra.',
    title: 'Animal Identity - Hydra',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio123',
    image: require('../assets/images/simulation/bio/12/blood-observation.jpg'),
    name: 'Observe blood and circulation from blood slide.',
    title: 'Human Physiology - Blood Slide',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio124',
    image: require('../assets/images/simulation/bio/12/renal-parameters.jpg'),
    name: 'Observe and identify permanent slide of kidney section.',
    title: 'Human Physiology - Kidney Section',
    route: '/biology-simulation-template',
  },
];

export const biology11 = [
  {
    id: 'bio111',
    image: require('../assets/images/simulation/bio/11/malvaceae.jpg'),
    name: 'Identification of Malvaceae family.',
    title: 'Plant Physiology - Malvaceae Family',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio112',
    image: require('../assets/images/simulation/bio/11/anaerobic-respiration.jpg'),
    name: `Test for CO2 emission in anaerobic respiration.`,
    title: 'Biotechnology - Anaerobic Respiration',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio113',
    image: require('../assets/images/simulation/bio/11/mitosis-division.jpg'),
    name: 'Different stages of mitosis division.',
    title: 'Cell Division - Mitosis',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio114',
    image: require('../assets/images/simulation/bio/11/observing-bacteria.jpg'),
    name: 'Observation of bacteria from sour curd.',
    title: 'Microorganisms - Bacteria Observation',
    route: '/biology-simulation-template',
  },
];

export const biology10 = [
  {
    id: 'bio101',
    image: require('../assets/images/simulation/bio/10/plant-cells.jpg'),
    name: 'Observation of plant cells (onion) using microscope.',
    title: 'Cell and Tissue - Plant Cell',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio102',
    image: require('../assets/images/simulation/bio/10/osmosis-test.jpg'),
    name: 'Experiment on cell to cell osmosis.',
    title: 'Cell Division - Osmosis',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio103',
    image: require('../assets/images/simulation/bio/10/amiba-observation.jpg'),
    name: 'Observation of animal cell (Amoeba) using microscope.',
    title: 'Transport in Organisms - Amoeba',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio104',
    image: require('../assets/images/simulation/bio/10/carbohydrates.jpg'),
    name: 'Identification of Carbohydrate, Protein and Fat.',
    title: 'Food, Nutrition and Digestion - Carbohydrate',
    route: '/biology-simulation-template',
  },
];

export const biology09 = [
  {
    id: 'bio091',
    image: require('../assets/images/simulation/bio/09/photosynthesis.jpg'),
    name: 'Experiment on the necessity of chlorophyll and light in photosynthesis.',
    title: 'Gaseous Exchange - Photosynthesis',
    route: '/biology-simulation-template',
  },
  {
    id: 'bio092',
    image: require('../assets/images/simulation/bio/09/flowering-plants.jpg'),
    name: 'Longitudinal section of different parts of a flower.',
    title: 'Cell and Tissue - Flower L.S.',
    route: '/biology-simulation-template',
  },
];
